import Skeleton from 'react-loading-skeleton';

import { FriendData } from '@/api/types';
import { Collapsible } from '@/components/shared/Collapsible/Collapsible.tsx';
import { formatNumberToStr } from '@/utils';

import cn from './styles.module.sass';

interface IFriendsListProps {
    friends: (FriendData & { id: string })[];
    isLoading: boolean;
}

export const FriendsList = ({ friends, isLoading }: IFriendsListProps) => {
    return isLoading ? (
        <Skeleton
            height={48}
            count={5}
            borderRadius={10}
            containerClassName={cn.skeletonContainer}
        />
    ) : (
        <div className={cn.container}>
            {friends.length === 0 ? (
                <div className={cn.noNumbers}>
                    <div className={cn.letterContainer}>
                        <span>#</span>
                    </div>
                    <div className={cn.noNumbersText}>Еще нет продаж друзей</div>
                </div>
            ) : (
                friends.map(friend => (
                    <Collapsible
                        key={friend.id}
                        isExpandable={false}
                        isArrowShown={false}
                        description={formatNumberToStr(friend.msisdn)}
                        title={friend.name}
                        rightContent={<span className={cn.points}>{friend.earned} Б</span>}
                        containerClassName={cn.collapsibleContainer}
                        headBlockClassName={cn.collapsibleHead}
                        numberInfoClassName={cn.numberInfo}
                    />
                ))
            )}
        </div>
    );
};
